import { useEffect, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MEMBERS_MAX, MEMBERS_MIN } from "@/lib/session-members";
import { maxMembersFromInput } from "./max-members-input";

/** Prekidač "Usluga sa više članova" i najveći broj članova; null = jedna osoba. */
export function ServiceMembersField({
  value,
  onChange,
  idPrefix = "service",
}: {
  value: number | null;
  onChange: (v: number | null) => void;
  idPrefix?: string;
}) {
  const enabled = value !== null;
  // Upisani tekst se drži dok nije ispravan broj; na izlazu iz polja vraća se
  // na spremljenu vrijednost.
  const [draft, setDraft] = useState(value === null ? "" : String(value));
  useEffect(() => {
    setDraft(value === null ? "" : String(value));
  }, [value]);
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Checkbox
          id={`${idPrefix}-members-enabled`}
          checked={enabled}
          onCheckedChange={(v) => onChange(v === true ? MEMBERS_MIN : null)}
        />
        <Label htmlFor={`${idPrefix}-members-enabled`}>Usluga sa više članova</Label>
      </div>
      {enabled && (
        <div className="space-y-2 pl-6">
          <Label htmlFor={`${idPrefix}-members-max`}>Najviše članova (uključujući klijenta koji zakazuje)</Label>
          <Input
            id={`${idPrefix}-members-max`}
            type="number"
            min={MEMBERS_MIN}
            max={MEMBERS_MAX}
            className="w-24"
            value={draft}
            onChange={(e) => {
              setDraft(e.target.value);
              const n = maxMembersFromInput(e.target.value);
              if (n !== null) onChange(n);
            }}
            onBlur={() => setDraft(String(value))}
          />
        </div>
      )}
      <p className="text-xs text-muted-foreground">
        Klijent kod zakazivanja može upisati emailove ostalih članova (npr. partnera). Oni dobijaju Meet link i podsjetnike.
      </p>
    </div>
  );
}
